/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_EndnoteInputs */

const en_reading_class_endnote = /** @type {(inputs: Reading_Class_EndnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endnotes`)
};

const es_reading_class_endnote = /** @type {(inputs: Reading_Class_EndnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas finales`)
};

/**
* | output |
* | --- |
* | "Endnotes" |
*
* @param {Reading_Class_EndnoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_endnote = /** @type {((inputs?: Reading_Class_EndnoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_EndnoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_endnote(inputs)
	return en_reading_class_endnote(inputs)
});